import createServer from "./createServer";
import { renderUrlToString } from "./renderURLtoString";
import { SSRApp, SSRAppOptions, RenderContext } from "./types";

let createSSRApp: <P extends RenderContext>(
  options: SSRAppOptions<P>
) => SSRApp<P>;

createSSRApp = <P extends RenderContext>(config: SSRAppOptions<P>) => {
  config.hydrate();
  return {
    config,
  } as SSRApp<P>;
};

if (import.meta.env.SSR) {
  createSSRApp = <P extends RenderContext>(config: SSRAppOptions<P>) => {
    if (import.meta.env.MODE !== "development") {
      if (!import.meta.env.VITE_PRERENDER_BUILD) {
        const { render, interceptResponse, configureServer } = config;
        const { app } = createServer({
          root: process.cwd(),
          render,
          interceptResponse,
          configureServer,
        });
        app.listen(3000, () => {});
      }
    }
    return {
      config,
      async renderToString(url: string, template: string, context: P) {
        const { render, interceptResponse, configureServer } = config;

        return await renderUrlToString({
          url,
          template,
          render,
          context,
        });
      }
    } as SSRApp<P>;
  };
}

export default createSSRApp;
